import de from './translations/de.json'
import en from './translations/en.json'
import { LANGUAGE } from '../env'

let lang = { de }
if (LANGUAGE === 'en') {
  lang = { en }
}

export default lang
